<template>
	<div style="display: flex; flex-direction: column; width: 100%;">
		<div v-if="displayedContent" style="background: #FFFFFF; box-shadow: 0px 0px 10px 0px #D9E7F1; border-radius: 2px 12px 12px 12px; flex-direction: column; margin-top: 15px; display: flex; width: 100%;">
			<div style="display: flex; justify-content: space-between; padding: 20px 20px 14px 20px;">
				<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: #1F2635; line-height: 22px;">{{this.$props.data.text == '帮我解读“当日需及时关心的长者”' ? '好的，以下是今日“需及时关心”的长者清单：' : ('好的，以下是“' + this.$props.data.text + '”')}} </div>
				<img v-if="!isUnfold" style="width: 24px; height: 24px; cursor: pointer;" src="../../assets/icon_home_ai_icon_3_1.png" alt="" draggable="false"  @click="clickUnflod" />
				<img v-if="isUnfold"  style="width: 24px; height: 24px; cursor: pointer;" src="../../assets/icon_home_ai_icon_3.png" alt="" draggable="false"  @click="clickUnflod" />
			</div>
			<div v-if="isUnfold" style="height: 1px; background: rgba(94, 103, 121, 0.1); margin-left: 20px; margin-right: 20px;"></div>
			<div v-if="isUnfold" style="padding-left: 35px; padding-right: 35px; margin-top: 15px;">
				<div v-html="displayedContent"></div>
			</div>
			<div v-if="isUnfold" style="display: flex; padding-left: 20px; padding-right: 20px; margin-bottom: 15px; justify-content: space-between; align-items: center;">
				<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #9EA4AF; line-height: 20px;">
					内容由AI生成
				</div>
				<div v-if="isFinish" class="copy_share" style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #9EA4AF; line-height: 20px; display: flex;">
					<div class="copy_share_copyBtn" style="display: flex; width: 66px; height: 30px; justify-content: center; align-items: center; border-radius: 5px; cursor: pointer; margin-right: 5px;" @click="clickCopyText()">
						<div class="copy_share_copoyImage" style="width: 16px; height: 16px; margin-right: 2px;" draggable="false" />
						<div class="copy_share_copyText" style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #9EA4AF; line-height: 20px;">复制</div>
					</div>
					<div id="shareContent" class="copy_share_shareBtn" style="display: flex; width: 66px; height: 30px; justify-content: center; align-items: center; border-radius: 5px; cursor: pointer; position: relative;" @click="share()">
						<div class="copy_share_shareImage" style="width: 16px; height: 16px; margin-right: 2px; background: green;"></div>
						<div class="copy_share_shareText" style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #9EA4AF; line-height: 20px;">分享</div>
						<div v-if="isShowQrCode" style="position: absolute; height: 221px; width: 200px; bottom: 27px; right: 0px;" @click.stop>
							<img style="position: absolute; width: 52px; height: 31px; bottom: -1px; right: 7px; z-index: 0;" src="../../assets/icon_home_ai_icon_11.png" alt="" draggable="false" />
							<div v-loading="qrCodeIsLoading" style="display: flex; justify-content: center; align-items: center; position: absolute; width: 200px; height: 200px; background: #FFFFFF; box-shadow: 0px 0px 10px 0px rgba(192,197,202,0.8); border-radius: 8px; z-index: 1;">
								<div id="qrCode" ref="qrCodeDetails"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="questions && questions.length > 0" style="display: flex; flex-direction: column; padding-left: 20px; padding-right: 20px; padding-bottom: 20px;">
				<div style="height: 1px; background: rgba(94, 103, 121, 0.1);"></div>
				<div style="display: flex; align-items: center; margin-top: 15px;">
					<img style="width: 16px; height: 16px; margin-right: 5px;" src="../../assets/icon_home_ai_icon_16.png" alt="" draggable="false" />
					<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #4A7CE8; line-height: 20px;">猜你想问</div>
				</div>
				<div style="display: flex; flex-direction: column;">
					<div v-for="(item, index) in questions || []" style="background: rgba(74, 124, 232, 0.2); border-radius: 20px 20px 20px 2px; backdrop-filter: blur(8px); display: flex; align-items: center; padding: 10px; align-self: flex-start; margin-top: 10px; cursor: pointer;" @click="clickAiQuestion(item)">
						<div style="width: 10px; height: 10px; border: 2px solid rgba(74, 124, 232, 0.5); border-radius: 5px; margin-right: 5px;"></div>
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 14px; color: #5E6779; line-height: 20px;">{{item}}</div>
					</div>
				</div>
			</div>

			<div v-if="toastStr" style="position: absolute; background: rgba(0, 0, 0, 0.5); border-radius: 8px; backdrop-filter: blur(8px); padding: 15px; display: flex; justify-content: center; align-items: center; left: 50%; top: 50%; transform: translate(-50%, -50%);">
				<img style="width: 16px; height: 16px; margin-right: 5px;" src="../../assets/icon_home_ai_icon_10.png" alt="" draggable="false" />
				<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: #FFFFFF; line-height: 22px;">{{ toastStr }}</div>
			</div>
		</div>
		<div v-if="isLoading" style="display: flex;  height: 120px; background: #FFFFFF; box-shadow: 0px 0px 10px 0px #D9E7F1; border-radius: 2px 12px 12px 12px; margin-top: 15px; overflow: hidden;" v-loading="isLoading" element-loading-text="AI分析中，请稍候..." class="loadingContent"></div>
	</div>
</template>
  
<script>

import {marked} from 'marked'
import QRCode from "qrcodejs2";
import axios from 'axios';
import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill';

export default {
	props: {
		data: {
			type: Object,
			default: null
		},
		dataIndex: {
			type: Number,
			default: null
		},
		msgArr: {
			type: Array,
			default: null
		},
		shareTitle: {
			type: String,
			default: ''
		},
		shareSubTitle: {
			type: String,
			default: ''
		},
		modelValue: null
	},
	computed: {
	},
	watch: {
		
	},
	data() {
		return {

			isUnfold: true,

			rawContent: '',
			displayedContent: '',
			interval: null,
			index: 1,

			toastStr: null,
			isShowQrCode: false,
			qrCodeIsLoading: false,

			isLoading: true,
			questions: null,

			jsonArr: [],
			isFinish: false,
			analysisString: '',


			eventSource: null,
			clientId: null,
			isRequestServerInterface: false, // 是否发起过接口打字的网络请求
			isPrint: false, // 是否开始打字
			isDataFull: false, // 字符串数据是否完整了
			wholeContent: ''

		};
	},
	created() {
		// 监听整个文档的点击事件
		let that = this;
		document.addEventListener('click', function (event) {
			// 检查点击是否发生在特定元素之外
			let qrCodeContainer = document.getElementById('shareContent');
			const isClickInsideElement = qrCodeContainer && qrCodeContainer.contains(event.target);
			if (!isClickInsideElement) {
				that.isShowQrCode = false;
			} else {

			}
		});
	},
	mounted() {
		this.$nextTick(() => {
			console.log('===传入的参数===', this.$props.data);
			// if (this.$props.data.text && this.$props.data.text != '帮我解读“当日需及时关心的长者”') {
			// 	this.beginGetMoreAiContent();
			// } else {
			// 	// this.beginGetAiContent();
			// 	this.startGetAiContent();
			// }
			this.startGetAiContent();
		})
	},
	methods: {
		// 获取 Cookie
		getCookie(c_name) {
			var name = c_name + '=';
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = decodeURIComponent(ca[i].trim()); // 解码
				if (c.indexOf(name) == 0) {
					return JSON.parse(c.substring(name.length, c.length));
				}
			}
			return '';
		},
		// 帮我解读
		startGetAiContent() {
			let protocol = window.location.protocol;
			let hostname = window.location.hostname;
			let port = window.location.port ? ':' + window.location.port : ''; // 如果端口号不是默认，则添加':'和端口号
			let whole = protocol + '//' + hostname + port;

			// 创建 EventSource 对象
			const eventSource = new EventSourcePolyfill(
				// 'http://192.168.1.16:9527' + '/api/sse/createConnect',
				// 'http://localhost:8081/api' + '/api/sse/createConnect',
				// 'http://localhost:8081' + '/api/sse/createConnect',
				// this.$store.state.baseUrl + '/api' + '/api/sse/createConnect',
				// this.$store.state.baseUrl + '/api/sse/createConnect', 
				whole + (port.indexOf(':80') >= 0 ? '/api' : '') + '/api/sse/createConnect',
				{
					headers: {
						'Authentication': this.getCookie('userInfo').token
					}
				}
			);

			this.eventSource = eventSource;
			// 监听 - 服务器发送的事件
			let that = this;
			eventSource.onmessage = function(event) {
				// console.log('SSE - 收到消息 - ', event.data);

				let data = JSON.parse(event.data);

				// 是否完成
				if (data && data.status && data.status == 'done') {
					that.wholeContent = data.data;
					that.isDataFull = true;
					that.eventSource.close(); // 客户端调用close方法来关闭连接
				}

				that.$emit('update:modelValue', data.sessionId);

				if (!that.isRequestServerInterface) {
					that.isRequestServerInterface = true;
					that.requestServerInterface(data.clientId);
				} else {
					that.isLoading = false;

					if (data.data) {
						marked.use({
							mangle: false,
							headerIds: false
						});
						let content = data.data || '';
						content = that.deleteAsking(data.data || '')
						// 将小波浪号替换为大波浪号,解决删除线的问题
						let dealContent = content.replace(/~/g, "～")

						that.rawContent = dealContent || '';
						
					}

					if (!that.isPrint) {
						that.isPrint = true;
						that.startTypewriterEffect();
					}
				}

			};
			// 监听 - 服务器关闭连接的事件
			eventSource.onclose = function(e) {
				console.log('SSE - 连接已关闭', e);
			};
			// 监听 - 服务器错误事件
			eventSource.onerror = function(e) {
				console.log('SSE - 连接出错', e);
			};
			// 监听 - 连接成功
			eventSource.addEventListener('open', (e) => {
				console.log('SSE - Open - 连接成功', e)
			})
			// 监听 - 收到自定义消息
			eventSource.addEventListener('message', e => {
				// console.log('SSE - Message - 收到自定义消息', e)
			})
			// 监听 - 出错了
			eventSource.addEventListener('error', e => {
				console.log('SSE - Error - 出错了', e)
			})
		},
		// 请求服务器的 SSE 推送接口
		requestServerInterface(clientId) {
			if (this.$props.data.text && this.$props.data.text != '帮我解读“当日需及时关心的长者”') {
				this.isLoading = true
				this.$get(
					'/api/dean/ai/timelyCareElderAiAskStream', 
					// 'http://192.168.1.16:9527/api/dean/ai/timelyCareElderAiAskStream', 
					{
						clientId: clientId,
						sessionId: this.$props.modelValue,
						question: this.$props.data.text || ''
					},
					(res) => {
						if (res.code == 0) {
						} else {
							this.isLoading = false;
							this.$emit(
								'requestFinish'
							);
						}
					},
					(err) => {
						this.isLoading = false;
						this.$emit(
							'requestFinish'
						);
					}
				);
			} else {
				this.isLoading = true
				this.$get(
					'/api/dean/ai/timelyCareElderAiStream', 
					// 'http://192.168.1.16:9527/api/dean/ai/timelyCareElderAiStream', 
					{
						clientId: clientId
					},
					(res) => {
						if (res.code == 0) {
							this.$emit(
								'changeShareTitle', 
								res.data.shareTitle ? res.data.shareTitle : '清雷AI助手'
							);
						} else {
							this.isLoading = false;
						}
					},
					(err) => {
						this.isLoading = false;
					}
				);
			}
		},
		// 开启打字效果
		startTypewriterEffect() {
			if (this.interval) {
				clearInterval(this.interval);
			}
			this.interval = setInterval(() => {
				if (this.index < this.rawContent.length) {
					this.index = this.index + 1;
					this.displayedContent = marked.parse(this.rawContent.substring(0, this.index)); // + '<div class="myClass">...</div>'
				} else {
					if (this.isDataFull == true) {
						this.displayedContent = marked.parse(this.rawContent.substring(0, this.index));
						this.analysisAsking(this.wholeContent);
						this.isFinish = true;
						clearInterval(this.interval);
						this.$emit(
							'requestFinish'
						);
						if (this.$props.dataIndex == 2) {
							let normalText = this.getNormalText(this.rawContent);
							let needResult = normalText.substring(0, 60);
							this.$emit(
								'changeShareSubTitle', 
								needResult
							);
						}
						this.$emit(
							'changeMsgArr', 
							{
								"content": this.deleteAsking(this.rawContent)
							}, 
							this.$props.dataIndex
						);
					} else {
						// this.displayedContent = marked.parse(this.rawContent.substring(0, this.index) + '<div class="myClass">AI分析中,请稍候...</div>'); // + '<div class="myClass">...</div>'
					}
				}
			}, 30); // 每100毫秒添加一个字符
		},
		// 解析 - 猜你想问
		analysisAsking(str) {
			// str = JSON.stringify(str).toString();
			console.log('===猜你想问解析===', str)
			let condition1 = '\n\n猜你想问：\n'
			let condition11 = '\n\n猜你想问：'
			let condition2 = '\n\n### 猜你想问：\n'
			let condition22 = '\n\n### 猜你想问：'
			let condition3 = '\n\n### 猜你想问\n'
			let condition33 = '\n\n### 猜你想问'
			let condition4 = '猜你想问：\n'
			let condition44 = '猜你想问：'
			let condition5 = '### 猜你想问：\n'
			let condition55 = '### 猜你想问：'
			let condition6 = '### 猜你想问\n'
			let condition66 = '### 猜你想问'

			if (str) {

				let matchingString = null;

				if (str.indexOf(condition1) > 0) {
					if (!matchingString) {
						matchingString = condition1;
					}
				}
				if (str.indexOf(condition11) > 0) {
					if (!matchingString) {
						matchingString = condition11;
					}
				}
				if (str.indexOf(condition2) > 0) {
					if (!matchingString) {
						matchingString = condition2;
					}
				}
				if (str.indexOf(condition22) > 0) {
					if (!matchingString) {
						matchingString = condition22;
					}
				}
				if (str.indexOf(condition3) > 0) {
					if (!matchingString) {
						matchingString = condition3;
					}
				}
				if (str.indexOf(condition33) > 0) {
					if (!matchingString) {
						matchingString = condition33;
					}
				}
				if (str.indexOf(condition4) > 0) {
					if (!matchingString) {
						matchingString = condition4;
					}
				}
				if (str.indexOf(condition44) > 0) {
					if (!matchingString) {
						matchingString = condition44;
					}
				}
				if (str.indexOf(condition5) > 0) {
					if (!matchingString) {
						matchingString = condition5;
					}
				}
				if (str.indexOf(condition55) > 0) {
					if (!matchingString) {
						matchingString = condition55;
					}
				}
				if (str.indexOf(condition6) > 0) {
					if (!matchingString) {
						matchingString = condition6;
					}
				}
				if (str.indexOf(condition66) > 0) {
					if (!matchingString) {
						matchingString = condition66;
					}
				}

				if (matchingString) {
					let arr = str.split(matchingString);
					if (arr && arr.length == 2) {
						let item = arr[1];
						let arr1 = item.split("@***");
						if (arr1 && arr1.length > 0) {
							this.questions = arr1;
						}
					}
				}

			}
		},
		// 删除多余的猜你想问
		deleteAsking(str) {

			let condition1 = '\n\n猜你想问：\n'
			let condition11 = '\n\n猜你想问：'
			let condition2 = '\n\n### 猜你想问：\n'
			let condition22 = '\n\n### 猜你想问：'
			let condition3 = '\n\n### 猜你想问\n'
			let condition33 = '\n\n### 猜你想问'
			let condition4 = '猜你想问：\n'
			let condition44 = '猜你想问：'
			let condition5 = '### 猜你想问：\n'
			let condition55 = '### 猜你想问：'
			let condition6 = '### 猜你想问\n'
			let condition66 = '### 猜你想问'

			if (str) {

				let matchingString = null;

				if (str.indexOf(condition1) > 0) {
					if (!matchingString) {
						matchingString = condition1;
					}
				}
				if (str.indexOf(condition11) > 0) {
					if (!matchingString) {
						matchingString = condition11;
					}
				}
				if (str.indexOf(condition2) > 0) {
					if (!matchingString) {
						matchingString = condition2;
					}
				}
				if (str.indexOf(condition22) > 0) {
					if (!matchingString) {
						matchingString = condition22;
					}
				}
				if (str.indexOf(condition3) > 0) {
					if (!matchingString) {
						matchingString = condition3;
					}
				}
				if (str.indexOf(condition33) > 0) {
					if (!matchingString) {
						matchingString = condition33;
					}
				}
				if (str.indexOf(condition4) > 0) {
					if (!matchingString) {
						matchingString = condition4;
					}
				}
				if (str.indexOf(condition44) > 0) {
					if (!matchingString) {
						matchingString = condition44;
					}
				}
				if (str.indexOf(condition5) > 0) {
					if (!matchingString) {
						matchingString = condition5;
					}
				}
				if (str.indexOf(condition55) > 0) {
					if (!matchingString) {
						matchingString = condition55;
					}
				}
				if (str.indexOf(condition6) > 0) {
					if (!matchingString) {
						matchingString = condition6;
					}
				}
				if (str.indexOf(condition66) > 0) {
					if (!matchingString) {
						matchingString = condition66;
					}
				}
				

				if (matchingString) {
					let arr = str.split(matchingString);
					if (arr && arr.length == 2) {
						let needStr = arr[0];
						return needStr;
					}
				} else {
					return str;
				}

			}
			return str;
		},
		// 点击猜你想问中的某个问题
		clickAiQuestion(item) {
			this.$emit(
				'clickAiAnalysis', 
				item
			);
		},
		// 点击拷贝AI内容文本
		clickCopyText() {
			let markdownString = this.deleteAsking(this.rawContent);
			const html = marked(markdownString); // 使用marked转换Markdown到HTML
			let text = html.replace(/<\/?[^>]+(>|$)/g, ''); // 使用正则表达式去掉HTML标记

			let textarea = document.createElement("textarea");
			textarea.value = text;
			document.body.appendChild(textarea);
			textarea.select();
			document.execCommand("copy");
			document.body.removeChild(textarea);
			this.toastStr = '复制成功';
			setTimeout(() => {
				this.toastStr = null;
			}, 2000);
		},
		// 获取正常的文本
		getNormalText(str) {
			let markdownString = str;
			const html = marked(markdownString); // 使用marked转换Markdown到HTML
			let text = html.replace(/<\/?[^>]+(>|$)/g, ''); // 使用正则表达式去掉HTML标记

			return text
		},
		// 点击分享
		share() {
			console.log('===msgArr===',  this.$props.msgArr)
			if (this.isShowQrCode) {
				this.isShowQrCode = !this.isShowQrCode;
				let container = document.getElementById('qrCode');
				container.innerHTML = '';
			} else {
				this.$post(
					'/api/dean/ai/timelyCareElderShare',
					{
						"msgArr": this.$props.msgArr,
						"showLastIndex": this.$props.dataIndex,
						"shareTitle": this.$props.shareTitle,
						"shareSubTitle": this.$props.shareSubTitle
					},
					(res) => {
						if (res.code == 0) {
							let shareJsonUrl = res.data || '';
							console.log('===分享链接===', shareJsonUrl)
							this.isShowQrCode = !this.isShowQrCode;
							this.$nextTick(function () {
								this.bindQRCode(shareJsonUrl);
							});
						} else {
						}
					},
					(err) => {
						console.log(err);
						// this.$message.error('服务端发生异常');
					}
				);
			}
		},
		// 生成二维码
		bindQRCode: function (params) {
			this.qrCodeIsLoading = true;
			setTimeout((e) => {
				new QRCode(this.$refs.qrCodeDetails, {
					// text: 'http://localhost:8080/#/aiShare?jsonUrl=https%3A%2F%2Fql-hospital-test.oss-cn-beijing.aliyuncs.com%2Fpub%2Ffile%2Feeg%2FADT_R20240814153930.json',
					text: this.$store.state.baseUrl + '/#/aiShare?jsonUrl=' + params,
					width: 160,
					height: 160,
					colorDark: "#333333", //二维码颜色
					colorLight: "#ffffff", //二维码背景色
					correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
				});
				this.qrCodeIsLoading = false;
			}, 1000);
		},
		// 点击了折叠按钮
		clickUnflod() {
			this.isUnfold = !this.isUnfold;
		},








		// 获取猜你想问的AI内容
		beginGetMoreAiContent() {
			// 1.请求接口
			this.isLoading = true
			this.$get(
				'/api/dean/ai/timelyCareElderAiAsk', {question: this.$props.data.text},
				(res) => {
					if (res.code == 0) {

						// 2.获取到的数据
						let choicesMessage = res.data || '';

						// 3.回传给分享所需的数据链接
						console.log('回传', [choicesMessage])
						this.$emit(
							'changeMsgArr', 
							{
								"jsonUrlArr": [choicesMessage]
							}, 
							this.$props.dataIndex
						);

						// 4.通过Json路径获取相应的数据
						axios({
							method: 'get',
							url: choicesMessage || '',
							headers: {
								'Content-Type': 'application/json',
								'Cache-Control': 'no-cache',
								'Pragma': 'no-cache'
							},
						})
						.then((response) => {
							this.isLoading = false;

							// 5.开始打印
							this.$nextTick(() => {
								marked.use({
									mangle: false,
									headerIds: false
								});
								let content = response ? response.content : '';
								content = this.deleteAsking(response ? response.content : '')
								// 将小波浪号替换为大波浪号,解决删除线的问题
								let dealContent = content.replace(/~/g, "～")

								this.rawContent = dealContent || '';
								// this.displayedContent = marked(dealContent);
								this.startTypewriterEffect();

								this.isFinish = true;

								this.analysisString = response ? response.content : '';

								this.$emit(
									'requestFinish'
								);
							});
						})
						.catch(() => {
							this.isLoading = false;
							this.$emit(
								'requestFinish'
							);
						});
					} else {
						this.isLoading = false;
						this.$emit(
							'requestFinish'
						);
					}
				},
				(err) => {
					this.isLoading = false;
					this.$emit(
						'requestFinish'
					);
				}
			);
		},
		// 开始获取AI内容
		beginGetAiContent() {
			// 本地测试AI动画
			// let dealContent = '前列腺问题是男性常见的一种健康问题，主要包括前列腺炎、前列腺增生和前列腺癌等。以下是一些预防和处理前列腺问题的方法：\n\n1. **定期检查**：定期进行前列腺特异性抗原（PSA）检测和直肠指检，有助于早期发现前列腺疾病。\n2. **健康饮食**：保持均衡的饮食，多吃蔬菜、水果和全谷物，减少高脂肪和高糖食物的摄入。\n3. **适量运动**：定期进行适量的体育锻炼，如散步、跑步、游泳等，有助于改善血液循环，减少前列腺疾病的风险。\n4. **避免久坐**：长时间久坐会增加前列腺的压力，应适当站立或走动，缓解前列腺的压力。\n5. **多喝水**：保持充足的水分摄入，有助于稀释尿液，减少尿路感染的风险。\n6. **戒烟限酒**：吸烟和过量饮酒都会增加前列腺疾病的风险，应尽量戒烟并限制酒精摄入。\n7. **及时治疗泌尿系统感染**：如有尿路感染等症状，应及时就医治疗，避免病情加重。\n\n如果出现前列腺问题的症状，如尿频、尿急、尿痛等，应及时就医，遵医嘱进行治疗。\n\n猜你想问：如何通过饮食来预防前列腺炎？@***前列腺增生的早期症状有哪些？@***前列腺癌的筛查方法有哪些？前列腺问题是男性常见的一种健康问题，主要包括前列腺炎、前列腺增生和前列腺癌等。以下是一些预防和处理前列腺问题的方法：\n\n1. **定期检查**：定期进行前列腺特异性抗原（PSA）检测和直肠指检，有助于早期发现前列腺疾病。\n2. **健康饮食**：保持均衡的饮食，多吃蔬菜、水果和全谷物，减少高脂肪和高糖食物的摄入。\n3. **适量运动**：定期进行适量的体育锻炼，如散步、跑步、游泳等，有助于改善血液循环，减少前列腺疾病的风险。\n4. **避免久坐**：长时间久坐会增加前列腺的压力，应适当站立或走动，缓解前列腺的压力。\n5. **多喝水**：保持充足的水分摄入，有助于稀释尿液，减少尿路感染的风险。\n6. **戒烟限酒**：吸烟和过量饮酒都会增加前列腺疾病的风险，应尽量戒烟并限制酒精摄入。\n7. **及时治疗泌尿系统感染**：如有尿路感染等症状，应及时就医治疗，避免病情加重。\n\n如果出现前列腺问题的症状，如尿频、尿急、尿痛等，应及时就医，遵医嘱进行治疗。\n\n猜你想问：如何通过饮食来预防前列腺炎？@***前列腺增生的早期症状有哪些？@***前列腺癌的筛查方法有哪些？前列腺问题是男性常见的一种健康问题，主要包括前列腺炎、前列腺增生和前列腺癌等。以下是一些预防和处理前列腺问题的方法：\n\n1. **定期检查**：定期进行前列腺特异性抗原（PSA）检测和直肠指检，有助于早期发现前列腺疾病。\n2. **健康饮食**：保持均衡的饮食，多吃蔬菜、水果和全谷物，减少高脂肪和高糖食物的摄入。\n3. **适量运动**：定期进行适量的体育锻炼，如散步、跑步、游泳等，有助于改善血液循环，减少前列腺疾病的风险。\n4. **避免久坐**：长时间久坐会增加前列腺的压力，应适当站立或走动，缓解前列腺的压力。\n5. **多喝水**：保持充足的水分摄入，有助于稀释尿液，减少尿路感染的风险。\n6. **戒烟限酒**：吸烟和过量饮酒都会增加前列腺疾病的风险，应尽量戒烟并限制酒精摄入。\n7. **及时治疗泌尿系统感染**：如有尿路感染等症状，应及时就医治疗，避免病情加重。\n\n如果出现前列腺问题的症状，如尿频、尿急、尿痛等，应及时就医，遵医嘱进行治疗。\n\n猜你想问：如何通过饮食来预防前列腺炎？@***前列腺增生的早期症状有哪些？@***前列腺癌的筛查方法有哪些？'
			// this.rawContent = dealContent || '';
			// this.displayedContent = marked(dealContent);
			// this.$nextTick(() => {
			// 	this.startTypewriterEffect();
			// });
			// return

			// 1.请求接口
			this.isLoading = true
			this.$get(
				'/api/dean/ai/timelyCareElderAi', {},
				(res) => {
					if (res.code == 0) {

						// 2.获取到的数据
						let fileIdList = res.data.fileIdList;
						let choicesMessage = res.data.choicesMessage;
						
						this.jsonArr = [choicesMessage];

						// 4.通过Json路径获取相应的数据
						axios({
							method: 'get',
							url: choicesMessage || '',
							headers: {
								'Content-Type': 'application/json',
								'Cache-Control': 'no-cache',
								'Pragma': 'no-cache'
							},
						})
						.then((response) => {
							this.isLoading = false;

							// 5.开始打印
							this.$nextTick(() => {
								marked.use({
									mangle: false,
									headerIds: false
								});
								let content = response ? response.content : '';
								content = this.deleteAsking(response ? response.content : '')
								// 将小波浪号替换为大波浪号,解决删除线的问题
								let dealContent = content.replace(/~/g, "～")

								if (this.$props.dataIndex == 2) {
									let normalText = this.getNormalText(dealContent);
									let needResult = normalText.substring(0, 60);
									this.$emit(
										'changeShareTitle', 
										res.data.shareTitle ? res.data.shareTitle : '清雷AI助手'
									);
									this.$emit(
										'changeShareSubTitle', 
										needResult
									);
								}

								this.rawContent = dealContent || '';
								// this.displayedContent = marked(dealContent);
								this.startTypewriterEffect();

								// 6.紧接着请求下一个接口
								if (fileIdList && fileIdList.length > 0) {
									this.requestNexAiContent(fileIdList);
								} else {
									// 3.回传给分享所需的数据链接
									console.log('回传', this.jsonArr)
									this.$emit(
										'changeMsgArr', 
										{
											"jsonUrlArr": this.jsonArr,
											"jsonType": 'array'
										}, 
										this.$props.dataIndex
									);

									this.isFinish = true;
									this.analysisString = response ? response.content : '';
									this.$emit(
										'requestFinish'
									);
								}
							});
						})
						.catch(() => {
							this.$emit(
								'requestFinish'
							);
						});
					} else {
						this.$emit(
							'requestFinish'
						);
					}
				},
				(err) => {
					this.$emit(
						'requestFinish'
					);
				}
			);
		},
		// 请求下一个 AI 接口
		requestNexAiContent(list) {
			if (list && list.length > 0) {
				// 1.请求接口
				this.$get(
					'/api/dean/ai/timelyCareElderAiSingle', {fileId: list[0]},
					(res) => {
						if (res.code == 0) {

							// 2.获取到的数据
							let choicesMessage = res.data;

							this.jsonArr.push(choicesMessage);

							// 4.通过Json路径获取相应的数据
							axios({
								method: 'get',
								url: choicesMessage || '',
								headers: {
									'Content-Type': 'application/json',
									'Cache-Control': 'no-cache',
									'Pragma': 'no-cache'
								},
							})
							.then((response) => {
								let content = response ? response.content : '';
								content = this.deleteAsking(response ? response.content : '')
								// 将小波浪号替换为大波浪号,解决删除线的问题
								let dealContent = content.replace(/~/g, "～")

								// 5.更新打印的字符串
								this.rawContent = this.rawContent + '\n\n' + content;
								this.displayedContent = marked(this.rawContent);
								this.startTypewriterEffect();

								// 6.处理 list 数组，紧接着请求下一个接口
								let copyList = JSON.parse(JSON.stringify(list));
								let newList = copyList.splice(1);
								if (newList && newList.length > 0) {
									this.requestNexAiContent(newList);
								} else {
									console.log('回传', this.jsonArr)
									// 3.回传给分享所需的数据链接
									this.$emit(
										'changeMsgArr', 
										{
											"jsonUrlArr": this.jsonArr,
											"jsonType": 'array'
										}, 
										this.$props.dataIndex
									);

									this.isFinish = true;
									this.analysisString = response ? response.content : '';
									this.$emit(
										'requestFinish'
									);
								}
							})
							.catch(() => {
								this.$emit(
									'requestFinish'
								);
							});
						} else {
							this.$emit(
								'requestFinish'
							);
						}
					},
					(err) => {
						this.$emit(
							'requestFinish'
						);
					}
				);
			}
		},
		// AI搜索 - 输入框用户自定义的
		aiSearch(text) {
			this.$emit(
				'clickAiAnalysis', 
				text
			);
		},
		// 停止请求
		stopPrint() {
			this.isStopPrint = true;
			this.isDataFull = true;
			this.eventSource.close(); // 客户端调用close方法来关闭连接
			if (this.interval) {
				clearInterval(this.interval);
			}
			// 打字完成了的回调用
			this.$emit(
				'typewritingFinish',
				this.pageData
			);
		}
	},
};
</script>
<style lang="scss" scoped>

.copy_share {
	.copy_share_copoyImage {
		background: url("../../assets/icon_home_ai_icon_6.png") no-repeat !important;
		background-size: 16px 16px !important;
	}
	.copy_share_shareImage {
		background: url("../../assets/icon_home_ai_icon_8.png") no-repeat !important;
		background-size: 16px 16px !important;
	}
}

.copy_share_copyBtn:hover {
	background: rgba(105, 145, 232, 0.2);
	.copy_share_copoyImage {
		background: url("../../assets/icon_home_ai_icon_7.png") no-repeat !important;
		background-size: 16px 16px !important;
	}
	.copy_share_copyText {
		color: rgba(74, 124, 232, 1) !important;
	}
}

.copy_share_shareBtn:hover {
	background: rgba(105, 145, 232, 0.2);
	.copy_share_shareImage {
		background: url("../../assets/icon_home_ai_icon_9.png") no-repeat !important;
		background-size: 16px 16px !important;
	}
	.copy_share_shareText {
		color: rgba(74, 124, 232, 1) !important;
	}
}

::v-deep .loadingContent {
	.el-loading-spinner {
		margin-top: -35px !important;
	}
}



</style>

<style>
.myClass {
	display: inline-block !important;
	color: rgba(74, 124, 232, 1) !important;
}
</style>